/**
 * React Query roots of the pursuit read models (GRW-12 header, GRW-13
 * thread). Full keys are `[root, tenantId, captureProjectId, …]`; mutations
 * that change a header fact or add a thread event invalidate by root.
 * A module of its own so `../hooks` can import it without a cycle.
 */ export const PURSUIT_HEADER_KEY = 'pursuit-header';
export const PURSUIT_THREAD_KEY = 'pursuit-thread';
/** Refetch the pursuit header and thread after a write that changes them. */ export function invalidatePursuitReads(queryClient) {
    return Promise.all([
        queryClient.invalidateQueries({
            queryKey: [
                PURSUIT_HEADER_KEY
            ]
        }),
        queryClient.invalidateQueries({
            queryKey: [
                PURSUIT_THREAD_KEY
            ]
        }),
        // GRW-35: a pursuit link write changes the pursuit-filtered graph's seeds.
        queryClient.invalidateQueries({
            queryKey: [
                'pursuit-graph'
            ]
        })
    ]).then(()=>undefined);
}
